import { Controller } from "@hotwired/stimulus"

// Filtert die generische Feature-Liste (Setting.keys feature_*) nach Titel oder Slug.
// Port aus atlastitan b90add687; "Keine Treffer"-Hinweis als serverseitig
// gerendertes (i18n) Element statt innerHTML.
export default class extends Controller {
  static targets = ["input", "item", "empty"]

  // Enter im Suchfeld soll nicht das Feature-Formular absenden.
  preventSubmit(event) {
    event.preventDefault()
  }

  filter() {
    if (!this.hasInputTarget) return

    const term = this.inputTarget.value.toLowerCase().trim()
    let visible = 0

    this.itemTargets.forEach((item) => {
      const title = (item.dataset.featureTitle || "").toLowerCase()
      const slug = (item.dataset.featureSlug || "").toLowerCase()
      const match = term === "" || title.includes(term) || slug.includes(term)
      item.classList.toggle("hidden", !match)
      if (match) visible++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible > 0)
    }
  }
}
